import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let token = localStorage.getItem('token');

    if (token == undefined || token === '' || token == null) {
      return true;
    } else {
      console.log('Auth Guard Res True ');
      const role = localStorage.getItem('role');

      if (role === 'prep') {
        this.router.navigate(['/license-dashboard']);
      } else if (role == 'remediation') {
        this.router.navigate(['/remediation-dashboard/page/sales-dashboard']);
      } else {
        return true;
      }
    }
  }
}
